import {Component, OnDestroy, OnInit} from "@angular/core";
import {SubscriptionService} from "../../../subscription/subscription.service";
import {ActivatedRoute, Router} from "@angular/router";
import {BuyService} from "../../../buy/buy.service";
import {Model} from "../../../app.model";
import {HttpClient} from "@angular/common/http";
import {Contact} from "../../../company/company.model";
import {CompanyService} from "../../../company/company.service";
import {CustomerService} from "../../../customer/customer.service";
import {WorkflowPartnerService} from "../workflow-partner.service";
import {WorkflowPartnerChangeSlaComponent} from "../workflow-partner-change-sla.component";
import {runInAction} from "mobx";

@Component({
    selector: 'app-workflow-partner-one-upgrade-sla',
    templateUrl: './workflow-partner-one-upgrade-sla.component.html',
    standalone: false
})
export class WorkflowPartnerOneUpgradeSlaComponent extends WorkflowPartnerChangeSlaComponent implements OnInit, OnDestroy {
  constructor(protected route: ActivatedRoute,
              protected router: Router,
              protected subscriptionService: SubscriptionService,
              protected buyService: BuyService,
              protected m: Model,
              protected http: HttpClient,
              protected workflowPartnerService: WorkflowPartnerService,
              protected customerService: CustomerService,
              protected companyService: CompanyService) {
    super(route, router, subscriptionService, buyService, m, http, workflowPartnerService, customerService, companyService);
  }

  async ngOnInit() {
    super.ngOnInit();
    await this.initWorkflow('upgrade-sla');

    this.checkOnInitPaymentStep(['address']);

    this.initialized = true;
  }

  protected checkSelectedProduct(ifStatement: boolean) {
    console.log('checkSelectedProduct override abstract method');
    return this.model.subscriptionSla.index === this.model.selectedSla.index
      || this.model.subscriptionSla.index > this.model.selectedSla.index;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  public onContact(c: Contact) {
    runInAction(() => {
      this.model.contact = c;
    })
    this.navigate(['address']);
  }

  public onContactBack() {
    // Switch to workflow change cu
    this.router.navigate(['/do', 'change-sla', this.applianceId]);
  }

  public onInvoiceAddressBack() {
    // Switch to workflow change cu
    this.navigate(['contact']);
  }

  public onPaymentMethodBack() {
    this.navigate(['address']);
  }

  public onBuy() {
    this.buyService.confirmPartnerQuotation().subscribe(
      (saleOrder: any) => {
        this.navigate(['complete'])
      }
    );
  }
}
